<template>
  <v-card>
    <v-card-title primary-title>
      <h3 class="headline mb-0">{{title}}</h3>
    </v-card-title>
    
    <!-- <v-card-text class="py-4 ma-3"> -->
    <v-card-text class="py-4">
      <v-layout row align-center>
        <v-progress-circular
          v-show="isProgress"
          indeterminate
          color="blue"
          size="20"
          width="2"
        ></v-progress-circular>
        <!-- <v-icon v-show="isOK" color="green">check_circle</v-icon> -->
        <!-- <v-icon v-show="state === 1" color="blue">radio_button_unchecked</v-icon> -->
        <v-icon v-show="state === 1" color="blue">trip_origin</v-icon>
        <v-icon v-show="isWarn" color="orange">warning</v-icon>
        <v-icon v-show="isError" color="red">error</v-icon>
        <!-- <span v-if="isOK" class="pl-2 green--text">OK</span> -->
        <span class="pl-2" v-html="message" />
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { STATE } from '@/constants.js'
export default {
  name: 'Result',
  props: {
    title: {
      type: String,
      required: true
    },
    state: {
      type: Number,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },
  computed: {
    isProgress () { return this.state === STATE.PROGRESS },
    isOK () { return this.state === STATE.OK },
    isWarn () { return this.state === STATE.WARN },
    isError () { return this.state === STATE.ERROR },
  }
}
</script>

<style>

</style>
